import { useSyncExternalStore } from "react";

const listeners = new Set<() => void>();
const subscribe = (listener: () => void) => {
  listeners.add(listener);
  window.addEventListener("storage", listener);
  return () => {
    listeners.delete(listener);
    window.removeEventListener("storage", listener);
  };
};

export function readPortfolioPreference(key: string | null): string | null {
  if (!key) return null;
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writePortfolioPreference(key: string, value: string) {
  try {
    localStorage.setItem(key, value);
    listeners.forEach((listener) => listener());
  } catch {
    // Storage restrictions must never block workspace navigation.
  }
}

export function usePortfolioPreference(key: string | null) {
  return useSyncExternalStore(
    subscribe,
    () => readPortfolioPreference(key),
    () => null
  );
}

export function portfolioPreferenceKey(
  user: string | null,
  org: string | undefined,
  resource: string,
  preference: string
) {
  return user && org
    ? `franklin:portfolio:v1:${encodeURIComponent(user)}:${encodeURIComponent(org)}:${resource}:${preference}`
    : null;
}
